module.exports = new __parcel__URL__("partner_2.fdee6297.jpg").toString();